import {AfterContentChecked, Component, EventEmitter, Input, Output} from '@angular/core';
import {AuthPolicyVO} from '../../../../generate/TopLevelDomainVO';
import {ChangeVO} from '../../../../generate/ChangeVO';
import {UtilService} from '../../../../util/util.service';

@Component({
  selector: 'auth-policy-view',
  templateUrl: './auth-policy-view.component.html',
  styleUrls: ['./auth-policy-view.component.scss']
})
export class AuthPolicyViewComponent implements AfterContentChecked {

  @Input()
  authPolicy: AuthPolicyVO;

  @Input()
  usersChange: ChangeVO;

  @Input()
  authPolicyChange: ChangeVO;
  policyChange: ChangeVO;
  @Input()
  lastchange: string;

  @Input()
  pendingRequestChangeID: string;

  @Output()
  edit = new EventEmitter<boolean>();
  @Input()
  viewMode: boolean;

  authPolicyViewable: AuthPolicyVO;

  constructor(private util: UtilService) {
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: any): void {
    this.authPolicyViewable = Object.assign({}, this.authPolicy);
    this.policyChange = this.util.getChange('PolicyConfigVO', this.authPolicyChange);
    if (this.usersChange != null) {
      this.buildAuthPolicyFromChangeVO();
    }
  }

  private buildAuthPolicyFromChangeVO() {
    this.authPolicyViewable.users = [];
    this.util.buildObjectFromChange(this.authPolicyViewable.users, this.usersChange);
  }

  ngAfterContentChecked(): void {
  }

  onEdit() {
    this.edit.emit(true);
  }
}
